import { Chassis } from '../../scene/Chassis';
import { useBodyPalette } from '../../scene/BodyFinish';
import { GLASS, HEADLIGHT, TAIL_LIGHT } from '../../scene/materials';

const AdtBody = () => {
  const palette = useBodyPalette('adt');
  return <group>
    <Chassis>
      <mesh position={[-0.2, 1.02, 0]}>
        <boxGeometry args={[7.2, 0.28, 0.26]} />
        <meshPhysicalMaterial {...palette.chassis} />
      </mesh>
      <mesh position={[0.05, 1.25, 0]}>
        <boxGeometry args={[0.55, 0.18, 2.18]} />
        <meshPhysicalMaterial {...palette.chassis} />
      </mesh>
    </Chassis>

    <mesh position={[2.3, 1.82, 0]}>
      <boxGeometry args={[1.8, 1.72, 2.42]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>
    <mesh position={[3.23, 2.14, 0]}>
      <boxGeometry args={[0.05, 0.55, 1.72]} />
      <meshPhysicalMaterial {...GLASS} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`cab-window-${side}`} position={[2.45, 2.16, side * 1.22]}>
      <boxGeometry args={[0.88, 0.52, 0.025]} />
      <meshPhysicalMaterial {...GLASS} />
    </mesh>)}
    <mesh position={[3.3, 1.18, 0]}>
      <boxGeometry args={[0.15, 0.32, 2.58]} />
      <meshPhysicalMaterial {...palette.edge} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`headlight-${side}`} position={[3.34, 1.38, side * 0.78]}>
      <boxGeometry args={[0.08, 0.18, 0.3]} />
      <meshPhysicalMaterial {...HEADLIGHT} />
    </mesh>)}

    <mesh position={[-1.52, 1.86, 0]} rotation={[0, 0, -0.08]}>
      <boxGeometry args={[4.5, 1.72, 2.58]} />
      <meshPhysicalMaterial {...palette.secondary} />
    </mesh>
    <mesh position={[-3.72, 1.68, 0]} rotation={[0, 0, 0.24]}>
      <boxGeometry args={[0.18, 1.45, 2.5]} />
      <meshPhysicalMaterial {...palette.secondary} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`bed-rail-${side}`} position={[-1.5, 2.78, side * 1.28]}>
      <boxGeometry args={[4.45, 0.1, 0.08]} />
      <meshPhysicalMaterial {...palette.edge} />
    </mesh>)}
    <mesh position={[0.85, 1.45, 0]}>
      <cylinderGeometry args={[0.3, 0.3, 0.34, 20]} />
      <meshPhysicalMaterial {...palette.edge} />
    </mesh>
    <mesh position={[-3.8, 1.08, 0]}>
      <boxGeometry args={[0.1, 0.18, 2.3]} />
      <meshPhysicalMaterial {...palette.chassis} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`tail-light-${side}`} position={[-3.85, 1.24, side * 0.94]}>
      <boxGeometry args={[0.08, 0.18, 0.26]} />
      <meshPhysicalMaterial {...TAIL_LIGHT} />
    </mesh>)}
  </group>;
};

export { AdtBody };
